export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12152.feeafb35.jpg";